﻿<template>

    <div class="pp-row">
        <div class="pp-row-text">
            <span class="pp-row-name">{{pass?.name}}</span>
            <span v-if="get_passenger_description(pass?.name ?? '')" class="pp-row-hint">{{get_passenger_description(pass?.name ?? '')}}</span>
        </div>
        <div class="pp-stepper" role="group" :aria-label="(pass?.name ?? '') + ' passengers'">
            <button type="button" class="pp-step" :disabled="passenger_total() <= 0" :aria-label="'Remove one ' + (pass?.name ?? '')" @click="remove_passenger">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14" /></svg>
            </button>
            <span class="pp-count" aria-live="polite">{{passenger_total()}}</span>
            <button type="button" class="pp-step" :disabled="!Can_Add()" :title="Add_Limit_Text()" :aria-label="'Add one ' + (pass?.name ?? '')" @click="add_passenger">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14" /></svg>
            </button>
        </div>
    </div>

</template>

<script lang="ts" src="./passenger.ts"></script>